<template>
  <div class="pl-3 pt-3 pb-2 bg-light-fracture1 rounded-top">
    <h4 class="modal-title">{{$t("フォーム編集.9")}}</h4>
  </div>
  <div class="p-3" v-if="mutateViewModel">

    <div class="pl-4">
      <el-form ref="inspectIconForm" :rules="rules" @submit.prevent :model="mutateViewModel.data.inspectMaster" label-position="top">
        <div class="pb-2">
          <h4>{{$t("フォーム編集.7")}} <require-tag /></h4>
          <!-- <el-input
            placeholder="項目名を入力"
            v-model="mutateViewModel.data.inspectMaster.statusName"
          ></el-input> -->
          <el-form-item prop="statusName">
            <el-input
              placeholder="項目名を入力"
              name="statusName"
              autocomplete="off"
              v-model="mutateViewModel.data.inspectMaster.statusName"
            ></el-input>
          </el-form-item>
        </div>
        <div class="pb-2">
          <h4>{{$t("フォーム編集.8")}} <require-tag /></h4>
            <el-radio v-model="mutateViewModel.data.inspectMaster.iconSelectType" label="1" size="large">{{$t("フォーム編集.11")}}</el-radio>
            <el-radio v-model="mutateViewModel.data.inspectMaster.iconSelectType" label="2" size="large">{{$t("フォーム編集.12")}}</el-radio>
        </div>
      </el-form>
      <h4>{{$t("フォーム編集.13")}} ({{$t("共通.19")}}{{mutateViewModel.data.inspectMaster.iconSetting.length}}{{$t("共通.20")}})</h4>
      <div class="overflow-auto pt-2" ref="iconListContainer" style="max-height:300px;border-top:1px solid silver;border-bottom:1px solid silver;">
        <div
          class="col-12"
          v-for="(item, index) in mutateViewModel.data.inspectMaster.iconSetting"
          :key="item.id"
        >
          <!-- @click.prevent="onClickProject(row)" -->
          <el-form :ref="`iconForm${index}`" :rules="rules" :model="item" label-position="top">
            <div class="d-flex mb-2">
              <div class="my-box flex-fill pr-1">
                <h5 v-if="index==0">{{$t("フォーム編集.7")}} <require-tag /></h5>
                <el-form-item prop="name">
                  <el-input
                    name="name"
                    autocomplete="off"
                    placeholder="項目名を入力"
                    v-model="item.name"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="my-box flex-fill pr-1">
                <h5 v-if="index==0">{{$t("フォーム編集.15")}}</h5>

                <el-select
                  placeholder=""
                  @change="changeIconType(item, $event)"
                  size="small"
                  v-model="item.iconFilePath"
                  >

                  <el-option v-for="icon in systemIconFileList"
                            class="select-primary"
                            :value="icon.key"
                            :label="icon.name"
                            :key="icon.name">
                            <img class="statusIcon" :src="iconKeyToPath[icon.key]" /><span class="ml-1">{{icon.name}}</span>
                  </el-option>
                  <template #prefix>
                    <!-- <img class="statusIcon" :src="systemIconFileList[(item.systemIconType - 0) > 0 ? (item.systemIconType - 0) - 1 : (item.systemIconType - 0)].path" /> -->
                    <img class="statusIcon" :src="iconKeyToPath[item.iconFilePath]" />

                  </template>
                </el-select>
              </div>
              <div class="my-box pr-2" >
                <h5 v-if="index==0">{{$t("フォーム編集.16")}}</h5>
                <div style="width:50px;" class="text-center">
                  <el-checkbox v-model="item.isDefault" @change="onChangeIconDefault(item, $event)" class="text-primary" label="" size="large" />
                </div>
              </div>
              <div class="my-box" :class="{'pt-4': index == 0}">

                <el-button icon="el-icon-top" @click="onChangeIconOrderUp(item)" class="border-primary text-primary" circle v-if="index != 0"></el-button>
                <el-button icon="el-icon-top" class="border-gray text-gray" circle disabled v-if="index == 0"></el-button>
                <el-button icon="el-icon-bottom" @click="onChangeIconOrderDown(item)" class="border-primary text-primary" circle v-if="index != (mutateViewModel.data.inspectMaster.iconSetting.length - 1)"></el-button>
                <el-button icon="el-icon-bottom" class="border-gray text-gray" circle disabled v-if="index == (mutateViewModel.data.inspectMaster.iconSetting.length - 1)"></el-button>
                <el-button icon="el-icon-delete" @click="onClickIconDelete(item)" class="border-primary text-white bg-primary" circle v-if="mutateViewModel.data.inspectMaster.iconSetting.length > 1"></el-button>
                <el-button icon="el-icon-delete" @click="onClickIconDelete(item)" class="border-gray text-white bg-gray" disabled circle v-if="mutateViewModel.data.inspectMaster.iconSetting.length == 1"></el-button>

              </div>
            </div>
          </el-form>
        </div>
        <div class="pl-3 pb-2 pt-2">
          <!-- <el-button size="medium" @click="onClickAddIcon" circle class="border-primary" v-if="mutateViewModel.data.inspectMaster.iconSetting.length < 10">
            <i class="fas fa-plus text-primary"></i>
          </el-button>
          <el-button size="medium" @click="onClickAddIcon" circle class="border-gray" disabled v-if="mutateViewModel.data.inspectMaster.iconSetting.length >= 10">
            <i class="fas fa-plus text-gray"></i>
          </el-button> -->

          <base-button type="primary" v-if="mutateViewModel.data.inspectMaster.iconSetting.length < maxItem" @click="onClickAddIcon"><i class="fas fa-plus text-white mr-2"></i>{{$t("フォーム編集.35")}} (最大{{maxItem}}件)</base-button>
          <base-button type="default"  disabled v-if="mutateViewModel.data.inspectMaster.iconSetting.length >= maxItem"><i class="fas fa-plus text-white mr-2"></i>{{$t("フォーム編集.35")}} (最大{{maxItem}}件)</base-button>
        </div>
      </div>

    </div>
    <div class="d-flex mt-4">
      <div class="my-box flex-fill pr-1">
        <base-button
          block
          type="secondary"
          @click="onClickIconModalCancel"
          >{{$t("共通.13")}}</base-button
        >
      </div>
      <div class="my-box flex-fill pl-1">
        <base-button
          v-if="!viewModel.data.inspectMaster.lockFlg"
          block
          type="primary"
          @click="onClickIconModalSave"
          >{{$t("共通.14")}}</base-button
        >
      </div>
    </div>
    <modal v-model:show="showConfirm" v-if="showConfirm" style="z-index:1051 !important;" body-classes="p-0">
      <confirm-modal
        :title="confirm.title"
        :message="confirm.message"
        :leftButtonLabel="confirm.leftButtonLabel"
        :rightButtonLabel="confirm.rightButtonLabel"
        @onClickLeftButton="onClickConfirmLeft"
        @onClickRightButton="onClickConfirmRight"
       />
    </modal>
  </div>
</template>
<style scoped>
</style>

<script>
import constants from "@/Config/constants";
import InspectMasterEditVM from "@/appViews/InspectMaster/ViewModel/InspectMasterEditVM"
import s3Util from "@/awsUtil/s3Util";
import ConfirmModal from "@/appViews/InspectMaster/Modal/ConfirmModal"
import Modal from "@/components/Modal";
import ValidateUtil from "@/appUtils/ValidateUtil"
import { useToast } from "vue-toastification";
import RequireTag from "@/appViews/components/Parts/requireTag"
import CustomizeUtil from "@/appUtils/CustomizeUtil"

export default {
  components: {
    ConfirmModal,
    Modal,
    RequireTag
  },
  props: {
    viewModel: {
      type: Object
    }
  },
  watch: {
    mutateViewModel: {
      handler: function () {
        this.modified = true
      },
      deep: true
    }
  },
  data() {
    return {
      mutateViewModel: null,
      showConfirm: false,
      confirm: {
        tirle: "削除確認",
        message: "",
        leftButtonLabel: "キャンセル",
        rightButtonLabel: "削除",
        leftButtonFn: null,
        rightButtonFn: null
      },
      modified: false,
      systemIconFileList: [
        {"type": "1", "name": "青丸", "key": constants.iconpath.icon1, "path": "blank" },
        {"type": "2", "name": "緑丸", "key": constants.iconpath.icon2, "path": "blank" },
        {"type": "3", "name": "灰丸", "key": constants.iconpath.icon3, "path": "blank" },
        {"type": "4", "name": "赤丸", "key": constants.iconpath.icon4, "path": "blank" },
        {"type": "5", "name": "黄丸", "key": constants.iconpath.icon5, "path": "blank" },
        {"type": "6", "name": "青星", "key": constants.iconpath.icon6, "path": "blank" },
        {"type": "7", "name": "緑星", "key": constants.iconpath.icon7, "path": "blank" },
        {"type": "8", "name": "灰星", "key": constants.iconpath.icon8, "path": "blank" },
        {"type": "9", "name": "赤星", "key": constants.iconpath.icon9, "path": "blank" },
        {"type": "10", "name": "黄星", "key": constants.iconpath.icon10, "path": "blank" },
        {"type": "11", "name": "青三角", "key": constants.iconpath.icon11, "path": "blank" },
        {"type": "12", "name": "緑三角", "key": constants.iconpath.icon12, "path": "blank" },
        {"type": "13", "name": "灰三角", "key": constants.iconpath.icon13, "path": "blank" },
        {"type": "14", "name": "赤三角", "key": constants.iconpath.icon14, "path": "blank" },
        {"type": "15", "name": "黄三角", "key": constants.iconpath.icon15, "path": "blank" },
      ],
      // systemIconFileList: constants.sumigomuicon,
      iconKeyToPath: {},
      rules: {
        statusName: [{ required: true, validator: this.checkStatusName, trigger: 'blur' }],
        name: [{ required: true, validator: this.checkName, trigger: 'blur' }]
      },
      toastId: "inspectIconModal",
      maxItem: 10,
      tenantId: "",
      isCustomized: false,
    };
  },
  beforeCreate() {
    //インスタンスは生成されたがデータが初期化される前
  },
  created() {

  },
  beforeMount() {
    //インスタンスが DOM 要素にマウントされる前
    this.init().then(function(){
      console.log(``)
    })
  },
  mounted() {
    //インスタンスが DOM 要素にマウントされた後
  },
  beforeUpdate() {
    //データは更新されたが DOM に適用される前
  },
  updated() {
    //データが更新され､且つ DOM に適用された後
  },
  beforeUnmount() {
    //Vue インスタンスが破壊される前
  },
  unmounted() {
    //Vue インスタンスが破壊された後
  },
  //ボタンイベントなどのメソッドはmethodsに
  methods: {
    async init() {
      try{
        // ViewModelをプロパティのオブジェクトから初期化
        this.initViewModel()
        this.modified = false

        const tenantStore = this.$store.state.tenant
        this.tenantId = tenantStore.id

        // カスタマイズレコードを取得する
        let customizeRecord = await CustomizeUtil.checkCustomizeRecords(this.tenantId);
        // カスタマイズ機能判定
        this.isCustomized = customizeRecord.key === CustomizeUtil.customizeSumigomu
        if (this.isCustomized) {
          this.systemIconFileList = constants.sumigomuicon
          this.maxItem = customizeRecord.maxItem
        }

        // アイコンをS3から取得
        const s3 = new s3Util()
        for (let i = 0;i < this.systemIconFileList.length;i++){
          console.log(`ステータスアイコン:${this.systemIconFileList[i].key}`)
          // this.systemIconFileList[i].path = await s3.getUrl(this.systemIconFileList[i].key)
          let signaturePath = await s3.getUrl(this.systemIconFileList[i].key)
          console.log(`ステータスアイコンPath:${signaturePath}`)
          // this.iconKeyToPath[this.systemIconFileList[i].key] = this.systemIconFileList[i].path
          this.iconKeyToPath[this.systemIconFileList[i].key] = signaturePath
        }
      } catch (e){
        console.log(JSON.stringify(e, null, "\t"))

      }
    },
    initViewModel() {
      if (!this.viewModel) {
        return
      }
      this.mutateViewModel = new InspectMasterEditVM()
      this.mutateViewModel = Object.assign(this.mutateViewModel, JSON.parse(JSON.stringify(this.viewModel)))

    },
    changeIconType(item, event) {
      console.log(event - 1)
      console.log(JSON.stringify(item))
    },
    onClickAddIcon() {
      try {
        if (this.mutateViewModel) {
          this.mutateViewModel.addIcon()
          this.$nextTick(function() {
            this.$refs.iconListContainer.scrollTop = this.$refs.iconListContainer.scrollHeight;
          }.bind(this))
        }
      } catch (e) {
        if (e.code) {
          console.log(e.error)
        } else {
          console.error(e.error)
        }
      }

    },
    /**
     * モーダルのキャンセル
     */
    onClickIconModalCancel() {
      if (this.modified) {
        // 変更確認
        this.confirm.message = `変更内容が破棄されますがよろしいですか？`
        this.confirm.leftButtonLabel = "編集に戻る"
        this.confirm.rightButtonLabel = "破棄する"
        this.confirm.leftButtonFn = function() {
          this.showConfirm = false
        }.bind(this)
        this.confirm.rightButtonFn = function() {
          this.showConfirm = false
          this.$emit("onCancel");
        }.bind(this)
        this.showConfirm = true
      } else {
        this.$emit("onCancel");
      }

    },
    /**
     * モーダルの保存
     */
    onClickIconModalSave() {
      this.hideToast()
      this.modified = false
      this.$refs.inspectIconForm.validate(function(result) {
        if (!result) {
          this.runToast("入力内容にエラーがあります。", "error")
          return
        }
        // 各行のバリデーションを実行する
        this.validateForm(0, function() {
          this.$emit("onSave", this.mutateViewModel);
        }.bind(this))
      }.bind(this))

    },
    /**
     * 各行毎のバリデーションを実行。
     */
    validateForm(index, callBack) {
      this.$refs[`iconForm${index}`].validate(function(result) {
        if (!result) {
          this.runToast("入力内容にエラーがあります。", "error")
          return
        }

        const max = this.mutateViewModel.data.inspectMaster.iconSetting.length - 1
        if (index >= max) {
          callBack()
        } else {
          this.validateForm(index + 1, callBack)
        }
      }.bind(this))
    },
    onChangeIconDefault(row) {
      this.mutateViewModel.changeDefaultSelect(row.id)
    },
    onChangeIconOrderUp(row) {
      this.mutateViewModel.changeOrder(row.order, row.order - 1, row.id)
    },
    onChangeIconOrderDown(row) {
      this.mutateViewModel.changeOrder(row.order, row.order + 1, row.id)
    },
    onClickIconDelete(row) {
      this.showConfirm = true
      this.confirm.message = `${row.name}を削除しますか？`
      this.confirm.leftButtonLabel = "キャンセル"
      this.confirm.rightButtonLabel = "削除"
      this.confirm.leftButtonFn = function() {
        this.showConfirm = false
      }.bind(this)

      this.confirm.rightButtonFn = function() {
        this.showConfirm = false
        this.mutateViewModel.removeIcon(row.id)

      }.bind(this)

    },
    onClickConfirmLeft() {
      this.confirm.leftButtonFn()
    },
    onClickConfirmRight() {
      this.confirm.rightButtonFn()
    },
    // ----------------
    // バリデーションメソッド
    // ----------------
    /**
     * 基本入力チェック処理
     */
    checkBase(value, callback, length=0, isRequire=false, isMail=false, isNumber=false) {

      if (isRequire) {
        // 必須チェック
        if (!value) {
          callback(new Error('入力必須項目です。'))
          return false
        }
      }
      if (length > 0 && value) {
        // 文字数チェック
        if (!((value + '').length <= length)) {
          callback(new Error(`${length}文字以内で入力して下さい。`))
          return false
        }
      }

      // 禁則文字チェック
      if (!ValidateUtil.checkKinsokuChar(value)) {
        callback(new Error(`禁則文字が指定されてます。\n禁則文字 ${process.env.VUE_APP_KINSOKU_CHARACTERS}`))
        return false
      }

      if (isMail) {
        // メールアドレス形式チェック
        if (!ValidateUtil.checkMailAddress(value)) {
          callback(new Error('正しくないメールアドレスの形式です。'))
          return false
        }
      }

      if (isNumber) {
        // 数値チェック
        if (isNaN(value)) {
          callback(new Error('数値で入力して下さい。'))
          return false
        }
      }

      return true
    },
    /**
     * 表示名の入力チェック
     */
    async checkName(rule, value, callback){
      // checkBase(value, callback, length=0, isRequire=false, isMail=false, isNumber=false)
      if (this.checkBase(value, callback, 50, true, false, false)) {
        callback()
      }
    },
    /**
     * 表示名の入力チェック
     */
    async checkStatusName(rule, value, callback){
      // checkBase(value, callback, length=0, isRequire=false, isMail=false, isNumber=false)
      if (this.checkBase(value, callback, 50, true, false, false)) {
        callback()
      }
    },
    // ----------------
    // トースト
    // ----------------
    /**
     * トースト表示
     */
    runToast(message, type) {
      const pos = 'bottom-center'
      const toast = useToast();
      toast[type](message, {
        hideProgressBar: true,
        icon: false,
        toastClassName: ["custome-toast-class"],
        closeButton: false,
        position: pos,
        id: this.toastId
      });
    },
    /**
     * トースト非表示
     */
    hideToast() {
      const toast = useToast();
      toast.dismiss(this.toastId)
    }
  }
};
</script>
